import { Converter } from '../types/converter';

export const angleConverter: Converter = {
  id: 'angle',
  name: 'Angle Converter',
  icon: 'CircleDot',
  categories: ['common', 'engineering'],
  units: [
    // Common angle units
    { name: 'Degree', symbol: '°', factor: 1 },
    { name: 'Radian', symbol: 'rad', factor: 57.29577951308232 },  // 180/π
    { name: 'Grad', symbol: '^g', factor: 0.9 },                   // 0.9° = 1 grad
    { name: 'Minute', symbol: "'", factor: 0.016666666666666666 }, // 1/60°
    { name: 'Second', symbol: '"', factor: 0.0002777777777777778 }, // 1/3600°
    
    // Alternative units
    { name: 'Gon', symbol: 'gon', factor: 0.9 },                   // Same as grad
    { name: 'Sign', symbol: 'sign', factor: 30 },                  // 1 sign = 30°
    { name: 'Mil', symbol: 'mil', factor: 0.05625 },              // 1/6400 of circle
    
    // Full rotations
    { name: 'Revolution', symbol: 'r', factor: 360 },              // 1 rev = 360°
    { name: 'Circle', symbol: 'circle', factor: 360 },             // 1 circle = 360°
    { name: 'Turn', symbol: 'turn', factor: 360 },                 // 1 turn = 360°
    
    // Partial rotations
    { name: 'Quadrant', symbol: 'quad', factor: 90 },              // 1 quadrant = 90°
    { name: 'Right angle', symbol: 'right', factor: 90 },          // 1 right angle = 90°
    { name: 'Sextant', symbol: 'sextant', factor: 60 }            // 1 sextant = 60°
  ]
};
